import React from "react"
import StatusPin from "./StatusPin"
import Shelf_Camera from "./Shelf_Camera.png"
import Cooler_TopLeft_cam from "./Cooler_TopLeft_cam.png"
import Cooler_TopRight_Cam from "./Cooler_TopRight_Cam.png"
import Cooler_BottomLeft_cam from "./Cooler_BottomLeft_cam.png"
import Cooler_BottomRight_Cam from "./Cooler_BottomRight_Cam.png"

const CameraIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="11.1428" height="13" rx="3" fill="#232323" />
    <rect y="1.85718" width="11.1428" height="11.1428" rx="3" fill="#787878" />
    <rect
      x="1.85742"
      y="3.71436"
      width="7.42856"
      height="7.42856"
      rx="3"
      fill="#3D3D3D"
    />
    <rect
      x="3.71484"
      y="5.57129"
      width="3.71428"
      height="3.71428"
      rx="1.85714"
      fill="black"
    />
  </svg>
)

export default function Camera({ data, type = "" }) {
  if (!data || Object.keys(data).length === 0) return null
  return (
    <div
      className={`camera-wrap camera-wrap-${type}`}
      title={data?.label || data?.key || "Camera"}
    >
      {/* {type} */}
      <span className="camera-icon">
        {type === "CM" && (
          <>
            <img src={Shelf_Camera} alt={Shelf_Camera + type} />
            <StatusPin type={type} online={!!data?.isOnline} flat />
          </>
        )}
        {type === "HCL" && (
          <>
            <img src={Cooler_TopLeft_cam} alt={Cooler_TopLeft_cam + type} />
            <StatusPin type={type} online={!!data?.isOnline} flat />
          </>
        )}
        {type === "HCR" && (
          <>
            <StatusPin type={type} online={!!data?.isOnline} flat />
            <img src={Cooler_TopRight_Cam} alt={Cooler_TopRight_Cam + type} />
          </>
        )}
        {type === "FCL" && (
          <>
            <img
              src={Cooler_BottomLeft_cam}
              alt={Cooler_BottomLeft_cam + type}
            />
            <StatusPin type={type} online={!!data?.isOnline} flat />
          </>
        )}
        {type === "FCR" && (
          <>
            <StatusPin type={type} online={!!data?.isOnline} flat />
            <img
              src={Cooler_BottomRight_Cam}
              alt={Cooler_BottomRight_Cam + type}
            />
          </>
        )}
      </span>
    </div>
  )
}
